import React from 'react';
import { useTranslation } from 'react-i18next';
import { Progress } from '@ktag/styleguide/dist/react';

interface Props {
  isSuccess: boolean;
}

const SubscribeConfirmationProgress = ({ isSuccess }: Props) => {
  const { t } = useTranslation('newsletter');

  const items = [
    {
      isDone: true,
      isActive: false,
      label: t('subscribe_progress_collect_data'),
      step: 1,
    },
    {
      isDone: true,
      isActive: false,
      label: t('subscribe_progress_confirmation'),
      step: 2,
    },
    {
      isDone: false,
      isActive: true,
      label: isSuccess
        ? t('subscribe_progress_finished')
        : t('subscribe_progress_failed'),
      step: 3,
    },
  ];

  return <Progress className="progress__list--normal" items={items} />;
};

export default SubscribeConfirmationProgress;
